module.exports = "/_next/static/images/SynthesizeImage@2x-67d9f1bfbe71506ee609da8bde6ddbf3.webp";